import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionOpenLaborTicketModal,
  actionOpenSetupActionModal,
} from 'lib/actions';
import { getSkipSetupParts } from 'lib/selectors/getSkipSetupParts';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';

/**
 * Returns a callback that starts the submit-work flow for the current labor
 * ticket context.
 *
 * Submit work opens the standard submit modal unless the current ticket is a
 * setup ticket and setup parts are skipped, in which case it opens the setup
 * action modal in submit mode.
 */
const useStartSubmitWork = () => {
  const dispatch = useDispatch();

  const skipSetupParts = useSelector(getSkipSetupParts);
  const currentLaborTicket = useSelector(getCurrentLaborTicket);
  const isSetupTicket = currentLaborTicket?.type?.toLowerCase() === 'setup';
  const useSetupActionModal = skipSetupParts && isSetupTicket;

  return useCallback(() => {
    if (useSetupActionModal) {
      return dispatch(actionOpenSetupActionModal('submit'));
    }
    return dispatch(actionOpenLaborTicketModal('submit'));
  }, [dispatch, useSetupActionModal]);
};

export default useStartSubmitWork;
